import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './core/login/login.component';
import { AirportSearchComponent } from './web5010/airport-search/airport-search.component';

import { AirportDashboardComponent } from './web5010/airport-dashboard/airport-dashboard.component';
import { AirportServicesComponent } from './web5010/airport-services/airport-services.component';
import { AirportBasedaircraftComponent } from './web5010/airport-basedaircraft/airport-basedaircraft.component';
import { AirportRunwayComponent } from './web5010/airport-runway/airport-runway.component';
import { AirportGeneralComponent } from './web5010/airport-general/airport-general.component';
import { AirportRemarksComponent } from './web5010/airport-remarks/airport-remarks.component';
import { AirportGridviewComponent } from './web5010/airport-gridview/airport-gridview.component';
import {AirportAdvancedsearchComponent} from './web5010/airport-advancedsearch/airport-advancedsearch.component';

const routes: Routes = [
  { path: '', component: AirportSearchComponent },
  { path: '5010Web', component: AirportSearchComponent },
{path: 'search', component: AirportSearchComponent},
{path : 'gridview', component: AirportGridviewComponent},
{path: 'advancedSearch',component :AirportAdvancedsearchComponent},
{path: 'dashboard', component: AirportDashboardComponent,
 children: [
  {path: 'services', component: AirportServicesComponent},
  {path: 'basedaircraft', component: AirportBasedaircraftComponent},
  {path: 'runway', component: AirportRunwayComponent},
  {path: 'general', component: AirportGeneralComponent},
  {path: 'remarks', component : AirportRemarksComponent}

],
runGuardsAndResolvers:'always'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation:'reload'}) ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
